export const environment = {
  production: true,
  // apiURL: 'http://localhost:3000/api',
  // imageBaseURL: 'http://localhost:3001',
  // apiURL: 'https://francaballero.net/api-node',
  // imageBaseURL: 'https://francaballero.net/api-node',
  apiURL: 'https://api.cookadhoc.com',
  imageBaseURL: 'https://assets.cookadhoc.com',
  version: '1.1.0',
};
